<template>
    <div>
      <div class="row">
        <div class="col-md-6">
          <section class="content">
            <div class="box info-box">
              <div class="box-header with-border">
                Check SMS
              </div>
              <div class="box-body">
                <div class="row">
                    
                  <div class="col-md-6">
                    <p><strong>Response:</strong>  {{data}}</p>
                    <form @submit.prevent="checkSMS()">
                    <label for="Mobile">Mobile</label>
                    <input type="number" v-model="form.mobile" name="mobile" class="form-control input-sm" placeholder="Enter mobile" />
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="1"  v-model="form.smsTemplate">
                      Loan Disbursement 
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="2"  v-model="form.smsTemplate">
                      Member Registration 
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="3"  v-model="form.smsTemplate">
                      Document Verification
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="4"  v-model="form.smsTemplate">
                      Due Emi SMS 
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="5"  v-model="form.smsTemplate">
                      Emi Collection 
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="6"  v-model="form.smsTemplate">
                      OTP SMS
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="7"  v-model="form.smsTemplate">
                      Login Credentials
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <label>
                      <input type="radio" name="smsTemplate" class="minimal" value="8"  v-model="form.smsTemplate">
                      Salary Disbursement 
                      <has-error :form="form" field="smsTemplate"></has-error>
                    </label>
                    <br>
                    <input class="btn btn-primary" type="submit" value="Submit" name="submit">
                    </form>
                  </div>
                  
                </div>
              </div>
            </div>
      
          </section>
        </div>
        <div class="col-md-6">
          <section class="content">
            <div class="box info-box">
              <div class="box-header with-border">
                Check EMAIL
              </div>
              <div class="box-body">
                <div class="row">
                    
                  <div class="col-md-6">
                    <p><strong>Response:</strong>  {{data}}</p>
                    <form @submit.prevent="checkEmail()">
                    <label for="Mobile">Email</label>
                    <input type="email" v-model="form.email" name="mobile" class="form-control input-sm" placeholder="Enter Email Id" />
                    <br>
                    
                    <input class="btn btn-primary" type="submit" value="Submit" name="submit">
                    </form>
                  </div>
                  
                </div>
              </div>
            </div>
      
          </section>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'smssetting',
    data () {
      return {
        form: new Form({
          id: '',
          smsTemplate: '',
          mobile: '',
          email: ''
        }),
        data: {}
      }
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      checkSMS () {
        this.$axios
          .get('checksms?mobile=' + this.form.mobile + '&smsTemplate=' + this.form.smsTemplate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.data = data
            // Toast.fire({
            //   icon: 'success',
            //   title: 'Branch Center Added Successfully'
            // })
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: error.response.data.error })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      checkEmail () {
        this.$axios
          .get('checksms?email=' + this.form.email, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.data = data
            // Toast.fire({
            //   icon: 'success',
            //   title: 'Branch Center Added Successfully'
            // })
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: error.response.data.error })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
    }
  }
  </script>
  <style scoped>
  .red {
    color: red;
  }
  .content {
    padding: 0px;
  }
  .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 4px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
</style>



// WEBPACK FOOTER //
// SmsSetting.vue?7073f769